import { Broker } from "@amzn/amazonmq-opsconsole-client";
import { widgetWithUnit } from "../utils";
import * as Arn from "@aws-sdk/util-arn-parser";
import {CELL_HEIGHT, CELL_WIDTH} from "./common";

export function getRabbitMetricAgentMetrics(broker: Broker): any[] {
    let metrics : any[] = [];
    let region = Arn.parse(broker.brokerInfo.arn).region;

    metrics.push(widgetWithUnit(
        "Collector execution time",
        region,
        [
            metricAgentCollectorTimeMetric(broker)
        ],
        0, // x
        0, // y
        CELL_WIDTH,
        CELL_HEIGHT,
        false,
        "Milliseconds"
    ))

    metrics.push(widgetWithUnit(
        "Collector failures",
        region,
        [
            metricAgentCollectorFailureMetric(broker)
        ],
        12, // x
        0, // y
        CELL_WIDTH,
        CELL_HEIGHT,
        false,
        "Count"
    ))

    return metrics;
}

export function metricAgentCollectorTimeMetric(broker: Broker) {
    return [
        {
            expression: `SEARCH('{AmazonMqRabbitService,MetricsCollector,BrokerId} MetricName=\\"MetricsCollectionTime\\" BrokerId=\\"${broker.id}\\"', 'Maximum')`
        }
    ]
}

export function metricAgentCollectorFailureMetric(broker: Broker) {
    return [
        {
            expression: `SEARCH('{AmazonMqRabbitService,MetricsCollector,BrokerId} MetricName=\\"MetricsCollectionFailures\\" BrokerId=\\"${broker.id}\\"', 'Sum')`
        }
    ]
}
